'use client'

import { Cell, Spacer, Text } from '@vinted/web-ui'
import { useInView } from 'react-intersection-observer'

import { useTracking } from '@marketplace-web/observability/event-tracker-data'
import {
  ItemPageItemsBlockHeaderPluginModel,
  itemPageChannelClickEvent,
  itemPageChannelViewEvent,
} from '@marketplace-web/item-page/item-page-data'

const ItemPageItemsBlockHeaderPlugin = ({
  title,
  headerCta,
  pluginName,
  itemId,
  contentSource,
}: ItemPageItemsBlockHeaderPluginModel & { pluginName: string }) => {
  const { track } = useTracking()
  const { ref } = useInView({
    onChange: inView => inView && track(itemPageChannelViewEvent({ itemId, contentSource })),
    triggerOnce: true,
  })

  const handleCtaClick = () => {
    track(
      itemPageChannelClickEvent({
        itemId,
        contentSource,
        target: 'horizontal_items_block_header_cta',
      }),
    )
  }

  const renderSuffix = () =>
    headerCta && (
      <a
        href={headerCta.url}
        onClick={handleCtaClick}
        target="_blank"
        data-testid="horizontal-items-block-header-suffix"
        rel="noreferrer"
      >
        <Text type="subtitle" theme="primary" text={headerCta.title} as="span" bold />
      </a>
    )

  return (
    <div ref={ref}>
      <Spacer size="x-large" />
      <Cell
        title={
          <Text type="title" as="h2">
            {title}
          </Text>
        }
        suffix={renderSuffix()}
        styling="tight"
        testId={`item-page-${pluginName}-plugin`}
      />
    </div>
  )
}

export default ItemPageItemsBlockHeaderPlugin
